import * as React from 'react';
import { createContext, useContext } from 'react';

const RoomIdContext = createContext<number | null>(null);
const RoomNameContext = createContext<string | null>(null);
const IsRoomRosteredContext = createContext<boolean>(false);

interface RoomIdProviderProps {
  children: React.ReactNode;
  roomId: number | null;
}

interface RoomNameProviderProps {
  children: React.ReactNode;
  roomName: string | null;
}

interface IsRoomRosteredProviderProps {
  children: React.ReactNode;
  isRoomRostered: boolean;
}
function RoomIdProvider({ children, roomId }: RoomIdProviderProps) {
  return (
    <RoomIdContext.Provider value={roomId}>{children}</RoomIdContext.Provider>
  );
}

function RoomNameProvider({ children, roomName }: RoomNameProviderProps) {
  return (
    <RoomNameContext.Provider value={roomName}>
      {children}
    </RoomNameContext.Provider>
  );
}

function IsRoomRosteredProvider({
  children,
  isRoomRostered,
}: IsRoomRosteredProviderProps) {
  return (
    <IsRoomRosteredContext.Provider value={isRoomRostered}>
      {children}
    </IsRoomRosteredContext.Provider>
  );
}

export function useRoomId() {
  const roomId = useContext(RoomIdContext);
  return roomId;
}

export function useRoomName() {
  const roomName = useContext(RoomNameContext);
  return roomName;
}

export function useIsRoomRostered() {
  const isRoomRostered = useContext(IsRoomRosteredContext);
  return isRoomRostered;
}

interface RoomProviderProps {
  children: React.ReactNode;
  roomId?: number;
  roomName?: string;
  isRoomRostered?: boolean;
}

export function RoomProvider({
  children,
  roomId,
  roomName,
  isRoomRostered,
}: RoomProviderProps) {
  return (
    <RoomIdProvider roomId={roomId}>
      <RoomNameProvider roomName={roomName}>
        <IsRoomRosteredProvider isRoomRostered={isRoomRostered}>
          {children}
        </IsRoomRosteredProvider>
      </RoomNameProvider>
    </RoomIdProvider>
  );
}
